import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { MOCKUP_ALT, MOCKUP_URL } from '../../data/images';
export function FinalSection() {
  return <section aria-labelledby="final-heading" className="bg-brand-blush px-5 py-16 text-center lg:px-8 lg:py-24" data-id="element-94" data-mp="9umry6rhian6">
      <div className="mx-auto max-w-4xl" data-id="element-95" data-mp="53wkmnzhzxpu">
        <h2 id="final-heading" className="mx-auto max-w-3xl font-display text-[2.4rem] font-bold leading-[1.06] text-brand-charcoal sm:text-[3.2rem]" data-id="element-96" data-mp="52vaclqb3f96">
          Stop Starting Every PMU Class <Accent data-id="element-97" data-mp="ew2b1ta3q72x">From Scratch.</Accent>
        </h2>
        <div className="mx-auto mt-5 max-w-2xl space-y-3 text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-98" data-mp="sspkuwn5krq9">
          <p data-id="element-99" data-mp="nv78sxdu9we1">Your teaching system is ready to explore.</p>
          <p data-id="element-100" data-mp="2uklvm41hxxjz">
            Six organized PMU teaching volumes and five additional educational resources, ready to support your next
            class.
          </p>
        </div>

        <img src={MOCKUP_URL} alt={MOCKUP_ALT} width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block aspect-[3/2] w-full max-w-[560px] object-contain" style={{
        filter: 'drop-shadow(0 30px 36px rgba(120, 90, 60, 0.22))'
      }} data-id="element-101" data-mp="2qhrnbyz8utw7" />

        <CtaBlock label="Get instant access now" className="mt-8" data-id="element-102" data-mp="349ze9a3ujqmz" />

        <p className="mt-5 font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-gold-dark" data-id="element-103" data-mp="398sjygcw6dcl">
          Secure Checkout • Instant Digital Access
        </p>
      </div>
    </section>;
}